import React from 'react';

import GenericMeetingInfoComponent from './GenericMeetingInfoComponent';
import CollegiumMeetingInfoComponent from './CollegiumMeetingInfoComponent';
import VericelMeetingInfoComponent from './VericelMeetingInfoComponent';

const regFormMapping = {
  collegium: CollegiumMeetingInfoComponent,
  vericel: VericelMeetingInfoComponent
};

const renderMeetingInfoComponent = (tenant) => {
  console.log('renderMeetingInfoComponent tenant', tenant);
  const MeetingInfoComponent = regFormMapping[tenant]
    ? regFormMapping[tenant]
    : GenericMeetingInfoComponent;
  return <MeetingInfoComponent tenant={tenant} />;
};

export default renderMeetingInfoComponent;
